var React = require('react');
var ReactNative = require('react-native');
var NativeAppEventEmitter = require('./wrappers/NativeAppEventEmitter-wrapper');


var Animated = require('./wrappers/Animated')

var Icon = require('./wrappers/ReUpIcon');

var ReUpScrollView = require('./ReUpScrollView.js');
var ShadowView = require('./ShadowView.js');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var PriceChooserView = require('./PriceChooserView.js');
var PaymentMethodChooserView = require('./PaymentMethodChooserView.js');
var AnalyticsManager = require('./AnalyticsManager');
var ProgressOverlay = require('./ProgressOverlay.js');

// var CardIO, { CardIOConstants } = require('react-native-card.io')
// import CardIO, { CardIOConstants } from 'react-native-card.io';
var CardIO = require('./CardIO.js');

var MAX_CREDIT = parseFloat(10);
var lastSelectedAmount = null;

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton
} = MK;

var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText.js');

var FeedCard = require('./feedCard.js');

var {
  StyleSheet,
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  Platform,
  Animated
} = ReactNative

function removeSpaces(str)
{
  return str.replace(/\s+/g, '');
}

var AddCredit = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    var appManager = this.props.appManager;
    var user = appManager.currentUser();

    return {
      layout : this.props.initialLayout,
      user:user,
      purchaseButtonTitle:appManager.getLocalizationManager().localizedStringForKey("PURCHASE_BUTTON"),
      refreshDisabled:false,
      spinnerText: appManager.getLocalizationManager().localizedStringForKey("CHECKING_HUD"),
      shouldShowSpinner: false,
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;

    var appManager = this.props.appManager;
    this.props.appManager.getDataType("Transactions",function(transactions)
    {
      var sortedTransactions = transactions.sort(function(a,b)
      {
        return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
      })
      var initialValue = null;
      for( var i = 0; i < sortedTransactions.length; i++ )
      {
        var transaction = sortedTransactions[i];
        if( typeof transaction.Credit !== 'undefined' && transaction.Credit != null && parseInt(transaction.Credit) > 0 )
        {
          initialValue = parseInt(transaction.Credit);
          break;
        }
      }
      if( initialValue != null )
      {
        setTimeout(()=>
        {
          if( typeof thisThing._ref_PriceChooserView !== 'undefined' ) thisThing._ref_PriceChooserView.setAmount(initialValue);
        },10)
      }
    });
  },

  componentWillUnmount : function()
  {
    if( typeof this._ref_PriceChooserView !== 'undefined' ) lastSelectedAmount = this._ref_PriceChooserView.getAmount();
  },

  amount : function()
  {
    return this._ref_PriceChooserView.getAmount();
  },

  amountText : function()
  {
    return this._ref_PriceChooserView.getAmountText();
  },

  submit : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    var transactionConfirmTitle = locManager.localizedStringForKey("ADDCREDIT_CONFIRM_ALERT_TITLE");
    var transactionConfirmBody = locManager.localizedStringForKeyAndParams("ADDCREDIT_CONFIRM_ALERT_BODY", [this.amountText()]);
    var yesText = locManager.localizedStringForKey("YES_ALERT_BUTTON");
    var noText = locManager.localizedStringForKey("NO_ALERT_BUTTON");

    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");

    var paymentSuccessTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_TITLE");
    var paymentSuccessBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_BODY");
    var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");

    var paymentFailTitle = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_TITLE");
    var paymentFailBody = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_BODY");
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;

    if( useInterstitialFlow )
    {
      thisThing.setState({shouldShowSpinner: true});
      this.makePayment();
    }
    else
    {
      appActions.showAlert(transactionConfirmTitle,transactionConfirmBody,[noText, yesText],[appActions.hideAlert, function()
      {
        appActions.hideAlert();
        appActions.setSpinnerShown(true, processingHUD);
        thisThing.makePayment();
      }, appActions.hideAlert], function(){})
    }
  },

  makePayment: function()
  {
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var paymentMethodChooser = thisThing._ref_paymentMethod;
    var paymentMethod = paymentMethodChooser.getPrimaryPaymentMethod();

    var useCreditFeature = thisThing.props.appManager.getFeatureForName("UseCredit");
    var shouldShowUseCredit = typeof useCreditFeature !== 'undefined' && useCreditFeature != null && !useInterstitialFlow && !thisThing.props.appActions._navigator.featureIsInStack(useCreditFeature);

    NetworkManager.submitPayment( appManager, thisThing.amount(), paymentMethod, function(data)
    {
      AnalyticsManager.logPurchaseEvent(appManager, thisThing.amount(), true);
      if ( !useInterstitialFlow )
      {
        appActions.setSpinnerShown(false);
      }
      else
      {
        thisThing.setState({shouldShowSpinner: false});
      }

      var user = appManager.currentUser();
      user[ModelConstants.Credits] = parseFloat(user[ModelConstants.Credits]) + parseFloat(thisThing.amount());
      appManager.setCurrentUser(user, function()
      {
        var paymentSuccessTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_TITLE");
        var paymentSuccessBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_BODY");
        var useCreditBody = locManager.localizedStringForKey("PAY_NOW_ALERT_BODY", 'Would you like to pay now?');
        var yesText = appManager.getFeatureForName("UseCredit").data.title;
        var noText = locManager.localizedStringForKey("LATER_ALERT_BUTTON", "Later");
        var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");

        if ( useInterstitialFlow )
        {
          thisThing.props.extras.addCreditDidFinish((appActions)=>
          {
            if ( typeof useCreditFeature !== 'undefined' )
            {
              appActions.showAlert(paymentSuccessTitle,useCreditBody,[noText, yesText],[
                function()
                {
                  appActions.hideAlert();
                },function()
                {
                  appActions.requestFeatureName('UseCredit');
                  appActions.hideAlert();
                }
              ]);
            }
          })
        }
        else if ( shouldShowUseCredit )
        {
          appActions.showAlert(paymentSuccessTitle,useCreditBody,[noText, yesText],[
          function()
          {
            appActions.hideAlert();
          },function()
          {
            appActions.requestFeatureName('UseCredit');
            appActions.hideAlert();
          }]);
        }
        else
        {
          appActions.showAlert(paymentSuccessTitle,paymentSuccessBody,[okayText],[function(){appActions.requestPop(false);appActions.hideAlert();}]);
        }
      });
    }, function(data)
    {
      var paymentFailTitle = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_TITLE");
      var paymentFailBody = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_BODY");
      var useInterstitialFlow = typeof thisThing.props.extras !== 'undefined' && thisThing.props.extras.useInterstitialFlow;
      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
      AnalyticsManager.logPurchaseEvent(appManager, thisThing.amount(), false);
      if ( !useInterstitialFlow )
      {
        appActions.setSpinnerShown(false);
        appActions.showAlert(paymentFailTitle,paymentFailBody,[okayText]);
      }
      else
      {
        thisThing.setState({shouldShowSpinner: false});
        thisThing.props.extras.addCreditDidFinish((appActions) =>
        {
          appActions.showAlert(paymentFailTitle, paymentFailBody, [okayText])
        })
      }
    }, function(data)
    {
      AnalyticsManager.logPurchaseEvent(appManager, thisThing.amount(), false);
      if ( !useInterstitialFlow )
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
      }
      else
      {
        thisThing.setState({shouldShowSpinner: false});
        thisThing.props.extras.showNetworkErrorAlert();
      }
    })
  },

  pullToRefreshView: function()
  {
    return this._ref_ptr
  },

  update: function()
  {

  },

  didUpdate: function(data)
  {
    var thisThing = this;
    this.props.appManager.getCurrentUser(function(user)
    {
      thisThing.setState({user:user});
    })
  },

  didStartChoosingPrice: function()
  {
    this._ref_ptr.setRefreshEnabled(false);
  },

  didEndChoosingPrice: function()
  {
    this._ref_ptr.setRefreshEnabled(true);
  },

  render: function()
  {
    var addCredit = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();
    var credit = user != null ? parseFloat(user[ModelConstants.Credits]) : '';
    var maxCredit = MAX_CREDIT;
    var creditRatio = parseFloat(credit) / parseFloat(maxCredit);
    var flexPositive = Math.round(100 * Math.min(creditRatio,1));
    var useMinWidth = flexPositive > 0;
    var flexNegative = 100 - flexPositive;
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
    var howMuchStatement = locManager.localizedStringForKey("HOW_MUCH_LABEL");
    var purchaseButtonTitle = this.state.purchaseButtonTitle;

    var paymentInfo = appManager.getPaymentInfo();
    var hasPrimaryPaymentMethod = false;
    for( var i = 0; i < paymentInfo.length; i++ )
    {
      if( paymentInfo[i].isPrimary )
      {
        hasPrimaryPaymentMethod = true;
        break;
      }
    }

    var priceChooserProps = {};
    if( lastSelectedAmount != null )
    {
      priceChooserProps.initialAmount = lastSelectedAmount;
    }
    if( typeof this.props.featureData.choiceValue !== 'undefined' )
    {
      priceChooserProps.choiceValue = this.props.featureData.choiceValue;
    }
    if( typeof this.props.featureData.choiceIndex !== 'undefined' )
    {
      priceChooserProps.initialIndex = this.props.featureData.choiceIndex;
    }

    return (
      <View style={[styles.container, {backgroundColor: generalColor}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }

        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this} refreshDisabled={this.state.refreshDisabled}>
        {
          !useInterstitialFlow ?
            <View style={[styles.instructionContainer, {backgroundColor: instructionColor}]}>
              <View style={{alignSelf:'center'}}>
                <ReUpText appManager={appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                  {creditsLeftStatement}
                </ReUpText>
              </View>
              <View style={{flex:1}} />
              <ReUpIconButton type={3}
                appManager={appManager}
                featureData={this.props.featureData}
                appActions={appActions}
                />
            </View>
          : null
        }
          <ShadowView appManager={appManager} layout={this.state.layout} />
          {
            hasPrimaryPaymentMethod ?
              <View>
                <ReUpText appManager={appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
                  {howMuchStatement}
                </ReUpText>
                <PriceChooserView ref={(c) => { this._ref_PriceChooserView = c; }} style={styles.choicesContainer} appManager={addCredit.props.appManager}
                  didStartChoosingPrice={addCredit.didStartChoosingPrice} didEndChoosingPrice={addCredit.didEndChoosingPrice}
                  initialLayout={addCredit.state.layout} didChangeValueAndText={(v,t)=>{addCredit.setState({purchaseButtonTitle:locManager.localizedStringForKey("PURCHASE_BUTTON") + " - " + t})}} {...priceChooserProps} />
              </View>
            :
              <ReUpText appManager={appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
                {locManager.localizedStringForKey("TO_ADD_CREDIT_LABEL")}
              </ReUpText>
          }
          <PaymentMethodChooserView ref={(c) => { this._ref_paymentMethod = c; }} enableEdit={!useInterstitialFlow} style={[styles.paymentMethodContainer,{marginBottom:10}]} appManager={appManager} appActions={appActions}
            initialLayout={this.state.layout} paymentInfo={paymentInfo}/>
          {
            hasPrimaryPaymentMethod ?
            <ReUpButton style={[styles.doneButton,{margin:10}]} appManager={appManager}
             text={purchaseButtonTitle}
              onPress={() => {
                addCredit.submit();
              }}
              />
            :
            null
          }
        </ReUpScrollView>
        {
          this.state.shouldShowSpinner ?
          <ProgressOverlay ref={(c) => { this._ref_spinner = c; }} key="spinner" isVisible={this.state.shouldShowSpinner}
            spinnerText={this.state.spinnerText} spinnerBody={this.state.spinnerBody}
            layout={this.state.layout} appManager={appManager}>
          </ProgressOverlay>
          : null
        }
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },


  // meter

  meterContainer: {
    margin:10,
    height:20,
    borderRadius:10,
    flexDirection:'row',
  },
  meterFiller: {
    margin:1,
    height:18,
    borderRadius:9,
  },
  meterAntiFiller: {
    height:18,
    borderRadius:9,
  },

  // body

  bodyText: {
    margin:10,
    textAlign:'left',
  },

  alertTitle: {
    margin:4,
    textAlign:'center',
  },

  // choices

  choicesContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:10,
    marginLeft:0,
    marginRight:0,
    height:50,
    alignItems:'center',
    justifyContent:'center'
  },
  choiceButton: {
    justifyContent:'center',
    flex:1,
    height:40,
  },

  // credit card
  oldCardContainer: {
    flexDirection:'row',
    margin:10,
    alignItems:'center',
    marginLeft:20,
    marginRight:20,
    justifyContent:'center',
  },
  creditCardIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding:4,
    opacity:.6,
  },
  creditCardText: {
    fontStyle:'italic',
    padding:4,
    flex:1,
    textAlign:'center',
    opacity:.6,
  },
  creditCardEditButton: {
    padding:4,
  },
  creditCardEditButtonIcon: {
    backgroundColor:'transparent'
  },

  paymentMethodContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:0,
    marginLeft:0,
    marginRight:0,
    height:60,
    flex:1,
    alignItems:'center',
    justifyContent:'center'
  },

  // new card
  cardNumberContainer: {
    flexDirection: 'row',
    margin:8,
    marginTop:0
  },

  textField: {
    flex:1,
    width:-1,
    height:50,
    marginTop:10
  },

  dateContainer: {
    flexDirection: 'row',
    alignItems:'flex-end',
    margin:8,
    marginTop:0,
  },
  dateField: {
    flex:-1,
    width:40,
    textAlign:'center',
  },
  cvvField: {
    flex:-1,
    width:80,
    textAlign:'center',
  },
  dateSlash: {
    paddingLeft:8,
    paddingRight:8,
    alignSelf:'flex-end',
    textAlign:'center',
  },

  doneButton: {
    justifyContent:'center',
    flex:1,
  },

  segmentContainer: {
    height:50,
    flex:1,
    alignSelf:'center'
  }
});

AddCredit.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( !isLoggedIn ) return [];
  else
  {
    var user = appManager.currentUser();
    var credit = parseFloat(user[ModelConstants.Credits]);
    if( credit > MAX_CREDIT) return [];

    var didSelect = function() {appActions.requestFeatureName("AddCredit")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : 0
    }];
  }
}


AddCredit.dataDependencies = ["Users", "Transactions"];

module.exports = AddCredit;
